
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $9b9373aea1bc1a91$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"IOlTS\",\"SpaceSettingsNavigationPortal.14026a02.js\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.134bc237.js\",\"eMbU0\",\"SpaceSelector.958952ac.js\",\"3wN5D\",\"ExternalSpaceLozenge.11ec98f6.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"10E5t\",\"custom-theme.b4014fa3.js\",\"1F7LX\",\"manual-triggers-modal.0cc2cfb8.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.b5fc7d49.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.43e284f0.js\",\"7EorR\",\"vendors~editor_atlaskit_md.b3627b45.js\",\"kuFG2\",\"link-extractors.978f4989.js\",\"1bbSu\",\"main.3ec6dbd2.js\",\"G9L45\",\"blockSubscription.ea6b7a36.js\",\"8HygH\",\"blockSubscription.runtime.74c7ccae.js\",\"bJVDE\",\"inlineCard.b4ee4392.js\",\"aQh37\",\"inlineCard.runtime.24365952.js\",\"jXx9i\",\"NativeCollabComponent.5e274adb.js\",\"ffEVr\",\"vendors~editor_icon.133cf444.js\",\"dLq4a\",\"FullPageEditorComponent.eb2f20af.js\",\"2tIxk\",\"FullPageEditorComponent.runtime.7ce5454f.js\",\"8bhm4\",\"component-lazy.e38d34b0.js\",\"gT8XU\",\"page-icon.f824fb79.js\",\"6wr18\",\"vendors~editor_icon.4eaf7490.js\",\"kO0mz\",\"audio-icon.fbcabbb5.js\",\"jDjSj\",\"16.a7bb8323.js\",\"gQLjx\",\"angle-brackets-icon.20db672b.js\",\"kDqHr\",\"file-icon.18995418.js\",\"5i5pX\",\"folder-icon.b345e3be.js\",\"eA5B3\",\"image-icon.216fc15a.js\",\"4HZlX\",\"chart-bar-icon.c15b454b.js\",\"7jSfd\",\"list-bullet-icon.e3855909.js\",\"7AsyI\",\"video-icon.49ac0143.js\",\"jNyUd\",\"component.30faa9cf.js\",\"2fk6g\",\"16.9bf5873c.js\",\"huUvS\",\"16.f2efe4ea.js\",\"1oiJ6\",\"16.5bb2f63a.js\",\"lxiFd\",\"16.4af6f7cd.js\",\"eDqo1\",\"16.44627fd1.js\",\"6HBYC\",\"16.f126a592.js\",\"bYxCZ\",\"16.a686bbdc.js\",\"eTBsW\",\"16.18d8d725.js\",\"020xd\",\"16.3bccb64c.js\",\"ls0Um\",\"16.6eef16fe.js\",\"eVYW1\",\"16.75064efa.js\",\"f35QR\",\"16.505024b2.js\",\"aOY32\",\"branch.9b5335d9.js\",\"6fQco\",\"commit.a938a361.js\",\"1MWOL\",\"pull-request.846f5369.js\",\"9wPDc\",\"code.c1497b0c.js\",\"9atVd\",\"bug.7d98f635.js\",\"lm9Lt\",\"changes.a16c7882.js\",\"jiFtb\",\"epic.45ed21d8.js\",\"4S1SF\",\"incident.87888d10.js\",\"XZauT\",\"problem.1405fad3.js\",\"3MYQs\",\"work-item.9bce1579.js\",\"5zapo\",\"story.f30f5865.js\",\"9aQIt\",\"subtask.0f164285.js\",\"6SWFK\",\"task.cfed4024.js\",\"87j6O\",\"jira-icon.eb7336b7.js\",\"lQhaj\",\"priority-blocker-icon.86edb701.js\",\"iEn0J\",\"priority-critical-icon.d35bd24c.js\",\"d2etG\",\"priority-high-icon.b00e5bca.js\",\"2rWNg\",\"priority-highest-icon.ba893df2.js\",\"akInk\",\"priority-low-icon.420b97eb.js\",\"6zoNk\",\"priority-lowest-icon.5c165837.js\",\"1MCFU\",\"priority-major-icon.d82ce890.js\",\"gz7jV\",\"priority-medium-icon.829e349d.js\",\"5Bj6b\",\"priority-minor-icon.4902bedb.js\",\"89ync\",\"priority-trivial-icon.4e027d6b.js\",\"7aMek\",\"component-lazy.817fd48d.js\",\"mhlT3\",\"SpaceSelector.2f7ff2ad.js\",\"dtpmo\",\"SpaceSelector.ead533ff.js\",\"2Sb1F\",\"emoji.ae541b7f.js\",\"byHKo\",\"emoji.runtime.cb239c29.js\",\"2qnH2\",\"CommentEditor.cea7a51b.js\",\"8HygH\",\"blockSubscription.runtime.74c7ccae.js\",\"aQh37\",\"inlineCard.runtime.24365952.js\",\"2tIxk\",\"FullPageEditorComponent.runtime.7ce5454f.js\",\"byHKo\",\"emoji.runtime.cb239c29.js\",\"4yUSc\",\"PremiumLozenge.d0aafec4.js\",\"ePA5l\",\"Lozenge.6b6c5ac2.js\",\"5pvpJ\",\"datasourceTableView.686437f9.js\",\"1yVM6\",\"UpgradeEditionButton.dfa9171d.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.24b8f107.js\",\"6XCf4\",\"LearnMoreButton.b759425a.js\",\"cEqm7\",\"ExtensionConfigUpsell.f73b9544.js\",\"hOaAV\",\"ExtensionConfigUpsell.76ff350b.js\",\"amPsT\",\"InspectPermissionsDialog.52f50c34.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.24b8f107.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\"]"));


$parcel$global.rlb("DNq0w")
//# sourceMappingURL=SpaceSettingsNavigationPortal.runtime.7748aa26.js.map
